<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form #flujoVentaForm [formGroup]="formulario" novalidate>

    <!-- Fila 1: Código | Nombre | Naturaleza -->
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_CODIGO' | translate }}</label>
          <label class="falso-combo-texto">{{f.codigo.value}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
            {{ 'FLUJOVENTA.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_NOMBRE' | translate }}</label>
          <input type="text" pInputText id="nombre{{tabView.codigo}}"
                 name="nomNombre{{tabView.codigo}}"
                 autocomplete="off"
                 formControlName="nombre"
                 [maxlength]="50"
                 capitalize-reactive>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
            {{ 'FLUJOVENTA.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" *ngIf="tabView.codigo !== pasosEnum.DATOSBASICOS && tabView.codigo !== pasosEnum.FINPROCESO">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate }}</label>
          <p-multiSelect id="idTipoPersona{{tabView.codigo}}" name="nomTipoPersona{{tabView.codigo}}" [options]="lisTipoPersonas"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idsNaturaleza"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsNaturaleza.invalid">
            {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 2: Secuencia | Tipo de vinculación | Tipo de Ocupación (cuando aplica) -->
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_SECUENCIA' | translate }}</label>
          <p-dropdown disableTab id="idSecuencia{{tabView.codigo}}" name="nomSecuencia{{tabView.codigo}}" [options]="lisSecuencia" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                      *ngIf="!secFija"
                      formControlName="secuencia"
          ></p-dropdown>
          <label class="falso-combo-texto" *ngIf="secFija">{{f.secuencia.value}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.secuencia.invalid">
            {{ 'FLUJOVENTA.LBL_SECUENCIA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_TIPOVINCULACION' | translate }}</label>
          <p-multiSelect id="idVinculaciones{{tabView.codigo}}" name="nomVinculaciones{{tabView.codigo}}" [options]="lisVinculacion"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="vinculaciones"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.vinculaciones.invalid">
            {{ 'FLUJOVENTA.LBL_TIPOVINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" id="tipo-ocupacion-field" *ngIf="tabView.codigo !== pasosEnum.DATOSBASICOS && tabView.codigo !== pasosEnum.FINPROCESO && formulario.get('indicadorOcupacion').value">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_TIPOOCUPACION' | translate }}</label>
          <p-multiSelect id="idsOcupacion" name="idsOcupacion" [options]="listaTiposOcupacionesConfig"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         formControlName="idsOcupacion"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idsOcupacion.invalid">
            {{ 'FLUJOVENTATABVIEW.LBL_TIPOOCUPACION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 3: Descripción | Habilitado -->
    <div class="grid form-group align-items-center">
      <div class="col-12 md:col-9 lg:col-9">
        <div class="div-form">
          <label>{{ 'FLUJOVENTA.LBL_DESCRIPCION' | translate }}</label>
          <textarea id="idDescripcion{{tabView.codigo}}" name="nomDescripcion{{tabView.codigo}}" pInputTextarea rows="2"
                    capitalize-reactive maxlength="250"
                    formControlName="descripcion"></textarea>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 flex align-items-center justify-content-center gap-2">
        <p-inputSwitch formControlName="indicadorHabilitado" inputId="indicadorHabilitado{{tabView.codigo}}"></p-inputSwitch>
        <label for="indicadorHabilitado{{tabView.codigo}}" class="mb-0" style="cursor:pointer">{{ 'LBL_HABILITADO' | translate }}</label>
      </div>
    </div>

    <!-- Fila checkboxes + Ícono -->
    <div class="grid form-group">
      <div class="col-12">
        <div class="flex flex-wrap align-items-center gap-4"
             style="background-color: #f7f7f7; border-radius: 6px; padding: 0.75rem 1rem;">

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_PASOPRINCIPAL' | translate}}" binary="true"
                      id="indicadorPasoPrincipal"
                      formControlName="indicadorPasoPrincipal"
                      [disabled]="tabView.codigo === pasosEnum.DATOSBASICOS ? true: false"></p-checkbox>

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_PREAPROBADO' | translate}}" binary="true"
                      id="indicadorPreaprobado"
                      formControlName="indicadorPreaprobado"></p-checkbox>

          <p-checkbox *ngIf="tabView.codigo !== pasosEnum.DATOSBASICOS && tabView.codigo !== pasosEnum.FINPROCESO"
                      label="{{ 'FLUJOVENTATABVIEW.LBL_OCUPACION' | translate}}" binary="true"
                      id="indicadorOcupacion"
                      formControlName="indicadorOcupacion"></p-checkbox>

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_GESTORTERCEROS' | translate}}" binary="true"
                      id="indicadorGestorTerceros"
                      formControlName="indicadorGestorTerceros"></p-checkbox>

          <p-checkbox *ngIf="HabilitarindicadorVinculacionPorPerfil"
                      label="{{ 'FLUJOVENTATABVIEW.LBL_VINCULACIONPORPERFIL' | translate}}" binary="true"
                      id="indicadorVinculacionPerfil"
                      formControlName="indicadorVinculacionPerfil"></p-checkbox>

          <!-- Adjunto inline -->
          <div class="flex align-items-center gap-2 ml-auto">
            <label class="mb-0 font-bold">{{ 'FLUJOVENTA.LBL_ICONO' | translate }}</label>
            <img *ngIf="!carImagen && imagen"
                 style="height: 32px; border-radius: 4px; filter: invert(57%) sepia(68%) saturate(450%) hue-rotate(83deg) brightness(96%) contrast(90%);"
                 [src]="imagen" alt=""/>
            <div class="adjuntar-outlined">
              <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false"
                            chooseLabel="{{'BTN_ADJUNTAR' | translate}}"
                            chooseIcon="pi pi-paperclip"
                            (onBeforeUpload)="onBeforeSend($event)" mode="basic" [hidden]="carImagen"
                            (onValidSelect)="onSelect($event, $event.files)" fSize
                            (onUpload)="onUpload($event)" accept="image/*"
              ></p-fileUpload>
            </div>
            <div *ngIf="carImagen" class="flex align-items-center gap-1">
              <i class="fa fa-refresh fa-spin fa-fw"></i>
              <span>{{'LBL_CARGANDO' | translate }}</span>
            </div>
            <span *ngIf="f.idAdjunto.value && !carImagen" class="flex align-items-center gap-1">
              <i class="fa fa-file-o" aria-hidden="true"></i>
              <span style="max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{nomArchivo}}</span>
              <a (click)="cancelarAdjunto()" style="cursor:pointer; color: #dc3545; padding: 0 4px;">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
            </span>
          </div>

        </div>
      </div>
    </div>

    <!-- Sección código sección -->
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_CODIGOSECCION' | translate }}</label>
          <label class="falso-combo-texto">{{tabView.seccion?.codigo}}</label>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_SECCION' | translate }}</label>
          <label class="falso-combo-texto">{{tabView.seccion?.nombre}}</label>
        </div>
      </div>
    </div>

    <!-- Controles -->
    <form [formGroup]="forControl" novalidate>
      <div class="grid form-group align-items-center">
        <div class="col-12 md:col-8 lg:col-4">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTA.LBL_CAMPO' | translate }}</label>
            <p-dropdown disableTab id="idControl{{tabView.codigo}}" name="nomControl{{tabView.codigo}}" [options]="lisControl" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                        formControlName="idFuncionalidadControl"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="subControl && fControl.idFuncionalidadControl.invalid">
              {{ 'FLUJOVENTA.LBL_CAMPO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-2 lg:col-2 pt-4">
          <p-checkbox label="{{ 'FLUJOVENTA.LBL_BITACORA' | translate}}" binary="true"
                      id="indicadorBitacora"
                      name="indicadorBitacora"
                      formControlName="indicadorBitacora"></p-checkbox>
        </div>
        <div class="col-12 md:col-4 lg:col-4 pt-4">
          <button class="p-button-datatables" icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="button" (click)="agregarControl()"
                  pButton></button>
        </div>
      </div>
    </form>

    <div>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6"></div>
        <div class="col-12 md:col-6 lg:col-6">
          <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 [(ngModel)]="busqueda" [ngModelOptions]="{standalone: true}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')">
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" #dt
                   [value]="lisFlujoVentaControl" [loading]="carTabla"
                   [paginator]="true" [rows]="10" paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.codigoFuncionalidadControl}}</td>
                <td>{{row.funcionalidadControl}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorVisible" binary="true" [ngModelOptions]="{standalone: true}"
                              disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorBitacora" binary="true" [ngModelOptions]="{standalone: true}">
                  </p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-users" data-toggle="tooltip"
                            title="{{'FLUJOVENTA.BTN_ROLES' | translate}}" pButton
                            (click)="verRoles(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}" pButton style="background-color: red"
                            (click)="quitarControl(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                type="button" (click)="onSubmit()"
                pButton></button>
      </div>
    </div>
  </form>
</div>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"
          [(visible)]="mosModalRoles"
          *ngIf="mosModalRoles"
          [contentStyle]="{'width':'500px'}"
          header="{{ 'FLUJOVENTA.LBL_ROLESPERMISOS'  | translate}}"
          [modal]="true">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      {{ 'FLUJOVENTA.LBL_CAMPO'  | translate}} : <span style="font-weight: bold">{{objControlSeleccionado?.funcionalidadControl}}</span>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="colRoles"
               [value]="lisRoles"
               [paginator]="true" [rows]="4" paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.rol}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorEditar" binary="true"
                          disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true"
                          disabled="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="cerrarRoles()"></button>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd key="datos-basicos{{tabView.codigo}}">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
